import clsx from "clsx";
import style from "./P.module.css";

/* <P weight={500} 
        font="Arial" 
        size="max(1.3vw, 25px)"
        i={false} 
        marginBottom="1em" 
        color="#333" 
        fontStyle="italic" 
        textDecoration="underline" 
        textAlign="center">내용</P> */

function P(props) {
    const {
        weight,
        font,
        size,
        i,
        min,
        max,
        marginBottom,
        color,
        fontStyle,
        textDecoration,
        textAlign,
        ellipsis,
        overflow,
        whiteSpace
    } = props;

    // 폰트 크기 계산
    let fontSize = size;
    if (min) {
        fontSize = `max(${fontSize}, ${min})`;
    }
    if (max) {
        fontSize = `min(${fontSize}, ${max})`;
    }

    return (
        <p
            className={clsx(
                style.paragraph,
                ellipsis && style.ellipsis,
                props.hover && style.hover
            )}
            style={{
                fontWeight: weight,
                fontFamily: font,
                fontSize: fontSize,
                fontStyle: i ? "italic" : fontStyle ? fontStyle : "normal",
                marginBottom: marginBottom,
                textIndent: props.textIndent ? props.textIndent : null,
                color: color ? color : "inherit",
                textDecoration: textDecoration ? textDecoration : null,
                verticalAlign: props.verticalAlign ? props.verticalAlign : "middle",
                whiteSpace: whiteSpace || (ellipsis ? "nowrap" : null),
                textAlign: textAlign ? textAlign : null,
                padding: props.padding ? props.padding : null,
                margin: props.margin ? props.margin : null,
                backgroundColor: props.backgroundColor ? props.backgroundColor : null,
                border: props.border ? props.border : null,
                borderRadius: props.borderRadius ? props.borderRadius : null,
                cursor: props.cursor ? "pointer" : null,
                lineHeight: props.lineHeight ? props.lineHeight : null,
                opacity: props.opacity ? props.opacity : null,
                letterSpacing: props.letterSpacing ? props.letterSpacing : null,
                overflow: overflow || (ellipsis ? "hidden" : null),
                textOverflow: ellipsis ? "ellipsis" : null,
                display: ellipsis ? "block" : null,
                width: ellipsis ? "100%" : null,
                maxWidth: props.maxWidth || null
            }}
            onClick={props.onClick}
        >
            {props.children}
        </p>
    );
}

export default P;